import {
  Box,
  Button,
  CardMedia,
  Checkbox,
  Input,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import React, { ChangeEvent, useState } from "react";
import "react-phone-input-2/lib/bootstrap.css";
import CloseIcon from "@mui/icons-material/Close";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const SignupForm = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);

  const [activeStep, setActiveStep] = useState(0);

  const steps = ["General Details", "Address Details", " Bank Details", "Additional Documents"];


  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
    }
  };
  const [isOtpVerified, setIsOtpVerified] = useState(false);


  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (<>
          <form className="form" onSubmit={handleSubmit}>
            {/* IMAGE UPLOAD */}
            <div className="gap_p">
              <div className="control_group w_100">
                <label htmlFor="icon-button-file">Upload Logo</label>
                {image ? (
                  <div className="upload_image br_none" >
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia component="img" image={image} alt="photo" />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label className="upload_image br_none" htmlFor="icon-button-file">
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                      }}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const files = (event.target as HTMLInputElement).files;
                        if (files && files[0].type.includes("image")) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        } else {
                          setAlertType(0);
                          setShowAlert(true);
                          setAlertMessage("This field only accepts images.");
                        }
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img src="/static/images/user_placeholder.png" alt="icon" />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="icon" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>

              {/* FULL NAME */}
              <div className="control_group w_33">
                <label htmlFor="fullName">Full Name</label>
                <TextField
                  id="fullName"
                  name="fullName"
                  placeholder="Enter Full Name"
                  fullWidth
                />
              </div>

              {/* BUSINESS NAME */}
              <div className="control_group w_33">
                <label htmlFor="businessName">Business Name</label>
                <TextField
                  id="businessName"
                  name="businessName"
                  placeholder="Enter Business Name"
                  fullWidth
                />
              </div>

              {/* CONTACT EMAIL */}
              <div className="control_group w_33">
                <label htmlFor="email">Contact Email</label>
                <TextField
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Enter Email Address"
                  fullWidth
                />
              </div>

              {/* CONTACT PHONE */}
              <div className="control_group w_33">
                <label htmlFor="contactPhone">Contact Phone</label>
                <TextField
                  id="contactPhone"
                  name="contactPhone"
                  placeholder="+971"
                  fullWidth
                />
              </div>

              {/* SERVICE COVERAGE AREA (LOCATIONS) */}
              <div className="control_group w_33">
                <label>Service Coverage Area (Locations)</label>
                <Select fullWidth value={"default"}>
                  <MenuItem disabled value="default">Select</MenuItem>
                  <MenuItem value="Abu Dhabi">Abu Dhabi</MenuItem>
                  <MenuItem value="Dubai">Dubai</MenuItem>
                  <MenuItem value="Sharjah">Sharjah</MenuItem>
                  <MenuItem value="Ajman">Ajman</MenuItem>
                  <MenuItem value="Umm al-Quwain">Umm al-Quwain</MenuItem>
                  <MenuItem value="Ras al-Khaimah">Ras al-Khaimah</MenuItem>
                  <MenuItem value="Fujairah">Fujairah</MenuItem>
                </Select>
              </div>

              {/* CATEGORY MULTI SELECT */}
              <div className="control_group w_33">
                <label htmlFor="category">Category</label>
                <Select
                  multiple
                  displayEmpty
                  open={openCategory}
                  onOpen={() => setOpenCategory(true)}
                  onClose={() => setOpenCategory(false)}
                  value={selectedCategories}
                  renderValue={(selected) =>
                    selected.length === 0 ? (
                      <span style={{ color: "#999" }}>Select Category</span>
                    ) : (
                      (selected as string[]).join(", ")
                    )
                  }
                  fullWidth
                  MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
                >
                  <MenuItem
                    value="all"
                    onClick={(e) =>
                      handleSelectAll(e, categories, selectedCategories, setSelectedCategories)
                    }
                  >
                    <Checkbox
                      checked={
                        categories.length > 0 &&
                        selectedCategories.length === categories.length
                      }
                      indeterminate={
                        selectedCategories.length > 0 &&
                        selectedCategories.length < categories.length
                      }
                    />
                    <ListItemText
                      primary={
                        selectedCategories.length === categories.length
                          ? "Clear All"
                          : "Select All"
                      }
                    />
                  </MenuItem>

                  {categories.map((cat) => (
                    <MenuItem
                      key={cat}
                      value={cat}
                      onClick={(e) =>
                        handleItemClick(e, cat, selectedCategories, setSelectedCategories)
                      }
                    >
                      <Checkbox checked={selectedCategories.includes(cat)} />
                      <ListItemText primary={cat} />
                    </MenuItem>
                  ))}
                </Select>
              </div>

              {/* BUSINESS DESCRIPTION */}
              <div className="control_group w_100 ai_rec_btn">
                <label htmlFor="businessDescription">
                  Business Description
                  <p style={{ margin: 0 }}>(250 characters maximum)</p>
                </label>
                <TextField
                  id="businessDescription"
                  name="businessDescription"
                  placeholder="Enter Business Description"
                  multiline
                  fullWidth
                />
              
              </div>
            </div>
          </form>


        </>
        );
      // case 1:
      //   return (
      //     <div className="pricing-wrapper">
      //       <div className="ai_recommendation">
      //         <figure>
      //           <img src="/static/images/ai_icon.svg" alt="icon" />
      //         </figure>

      //         <h3>AI Recommendation</h3>
      //         <p>Pro subscription will be best as per your store.</p>
      //       </div>
      //       <div className="pricing-container">
      //         {/* Free Plan */}
      //         <div className="pricing-card special">
      //           <div className="icon">🎁</div>
      //           <h3>Free</h3>
      //           <h2>
      //             AED 0 <span>forever</span>
      //           </h2>
      //           <ul>
      //             <li>Up to 10 products</li>
      //             <li>Basic analytics</li>
      //             <li>Email support</li>
      //             <li>Payout Speed 48h</li>
      //             <li>Standard processing</li>
      //           </ul>

      //         </div>

      //         {/* Grow Plan */}


      //         {/* Pro Plan */}
      //         <div className="pricing-card">
      //           <div className="icon">💼</div>
      //           <p className="suggested"><img src="/static/images/ai_icon.svg" alt="" />AI Recommended</p>
      //           <h3>Pro</h3>
      //           <h2>
      //             AED 249 <span>per month</span>
      //           </h2>
      //           <ul>
      //             <li>Unlimited products</li>
      //             <li>Full AI suite</li>
      //             <li>Premium analytics</li>
      //             <li>Dedicated account manager</li>
      //             <li>Advanced marketing automation</li>
      //             <li>Payout Speed 5d</li>
      //             <li>Early access to features</li>
      //           </ul>

      //         </div>

      //         {/* Youth Plan */}
      //         <div className="pricing-card ">
      //           <div className="icon">🎁</div>
      //           <h3>Youth Innovators</h3>
      //           <h2>
      //             Free <span>for under 18</span>
      //           </h2>
      //           <ul>
      //             <li>All Pro features</li>
      //             <li>Mentorship program</li>
      //             <li>Educational resources</li>
      //             <li>Payout Speed 10d</li>
      //             <li>Special recognition badge</li>
      //           </ul>

      //         </div>
      //         {/* Pro Plan */}
      //         <div className="pricing-card">
      //           <div className="icon">💼</div>
      //           <h3>Pro</h3>
      //           <h2>
      //             AED 249 <span>per month</span>
      //           </h2>
      //           <ul>
      //             <li>Unlimited products</li>
      //             <li>Full AI suite</li>
      //             <li>Premium analytics</li>
      //             <li>Dedicated account manager</li>
      //             <li>Advanced marketing automation</li>
      //             <li>Payout Speed 5d</li>
      //             <li>Early access to features</li>
      //           </ul>

      //         </div>
      //         {/* Pro Plan */}
      //         <div className="pricing-card">
      //           <div className="icon">💼</div>
      //           <h3>Pro</h3>
      //           <h2>
      //             AED 249 <span>per month</span>
      //           </h2>
      //           <ul>
      //             <li>Unlimited products</li>
      //             <li>Full AI suite</li>
      //             <li>Premium analytics</li>
      //             <li>Dedicated account manager</li>
      //             <li>Advanced marketing automation</li>
      //             <li>Payout Speed 5d</li>
      //             <li>Early access to features</li>
      //           </ul>

      //         </div>
      //       </div>
      //     </div>
      //   );
      case 1:
        return (
          <form className="form">
            <div className="gap_p">

              {/* ADDRESS DETAILS */}
              <div className="control_group w_50">
                <label htmlFor="addressDetails">Address Details</label>
                <TextField
                  id="addressDetails"
                  name="addressDetails"
                  placeholder="Enter Full Address Details"
                  fullWidth
                />
              </div>

              {/* EMIRATE */}
              <div className="control_group w_50">
                <label htmlFor="emirate">Emirate</label>
                <Select
                  id="emirate"
                  fullWidth
                  value={"default"}
                >
                  <MenuItem disabled value="default">
                    Select Emirate
                  </MenuItem>
                  <MenuItem value="Abu Dhabi">Abu Dhabi</MenuItem>
                  <MenuItem value="Dubai">Dubai</MenuItem>
                  <MenuItem value="Sharjah">Sharjah</MenuItem>
                  <MenuItem value="Ajman">Ajman</MenuItem>
                  <MenuItem value="Umm Al Quwain">Umm Al Quwain</MenuItem>
                  <MenuItem value="Ras Al Khaimah">Ras Al Khaimah</MenuItem>
                  <MenuItem value="Fujairah">Fujairah</MenuItem>
                </Select>
              </div>

              {/* CITY */}
              <div className="control_group w_50">
                <label htmlFor="city">City</label>
                <TextField
                  id="city"
                  name="city"
                  placeholder="Enter City"
                  fullWidth
                />
              </div>

              {/* STREET NAME */}
              <div className="control_group w_50">
                <label htmlFor="streetName">Street Name</label>
                <TextField
                  id="streetName"
                  name="streetName"
                  placeholder="Enter Street Name"
                  fullWidth
                />
              </div>

              {/* BUILDING NAME/NUMBER */}
              <div className="control_group w_50">
                <label htmlFor="buildingName">Building Name/Number</label>
                <TextField
                  id="buildingName"
                  name="buildingName"
                  placeholder="Enter Building Name or Number"
                  fullWidth
                />
              </div>

            </div>
          </form>

        );
      case 2:
        return (
          <form className="form">
            <div className="gap_p bank_details">

              {/* BANK ACCOUNT NAME */}
              <div className="control_group w_50">
                <label htmlFor="bankAccountName">Bank Account Name (Mandatory)</label>
                <TextField
                  id="bankAccountName"
                  name="bankAccountName"
                  placeholder="Enter Bank Account Name"
                  fullWidth
                />
              </div>

              {/* BANK NAME */}
              <div className="control_group w_50">
                <label htmlFor="bankName">Bank Name (Mandatory)</label>
                <Select
                  id="bankName"
                  fullWidth
                  value="default"
                >
                  <MenuItem disabled value="default">
                    Select Bank
                  </MenuItem>
                  <MenuItem value="PNB">PNB</MenuItem>
                  <MenuItem value="SBI">SBI</MenuItem>
                  <MenuItem value="HDFC">HDFC</MenuItem>
                  <MenuItem value="ICICI">ICICI</MenuItem>
                </Select>
              </div>

              {/* IBAN */}
              <div className="control_group w_50">
                <label htmlFor="iban">IBAN (Mandatory)</label>
                <TextField
                  id="iban"
                  name="iban"
                  placeholder="Enter IBAN Number"
                  fullWidth
                />
              </div>

              {/* SWIFT / BIC CODE */}
              <div className="control_group w_50">
                <label htmlFor="swiftCode">Swift Code (Optional)</label>
                <TextField
                  id="swiftCode"
                  name="swiftCode"
                  placeholder="Enter Swift/BIC Code"
                  fullWidth
                />
              </div>

              {/* BANK DOCUMENT UPLOAD */}
              <div className="control_group w_100">
                <label htmlFor="bankDocument">Bank Document Upload (Optional)</label>
                <div className="upload_box">
                  <label className='upload_action' >
                    <input type="file" />
                    <p>
                      <img src="/static/images/upload_icon.svg" alt='icon' />
                      <strong>Click to upload or drag and drop</strong>
                    </p>
                  </label>
                </div>

              </div>

            </div>
          </form>

        );
      case 3:
        return (
          <form className="form">
            <div className="gap_p bank_details">
              <div className="control_group w_50">
                <label htmlFor="bankDocument">Document 1</label>
                <div className="upload_box">
                  <label className='upload_action' >
                    <input type="file" />
                    <p>
                      <img src="/static/images/upload_icon.svg" alt='icon' />
                      <strong>Click to upload or drag and drop</strong>
                    </p>
                  </label>
                </div>

              </div>
              <div className="control_group w_50">
                <label htmlFor="bankDocument">Document 2</label>
                <div className="upload_box">
                  <label className='upload_action' >
                    <input type="file" />
                    <p>
                      <img src="/static/images/upload_icon.svg" alt='icon' />
                      <strong>Click to upload or drag and drop</strong>
                    </p>
                  </label>
                </div>

              </div>

            </div>
          </form>
        );

      default:
        return <Typography>Unknown Step</Typography>;
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const handleReset = () => {
    setActiveStep(0);
    setIsOtpVerified(false);
  };

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Add login logic here
    navigate("/dashboard");
  };
  const [valueTabs, setValueTabs] = useState<number>(0);
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [valueTabs1, setValueTabs1] = useState<number>(0);

  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  const categories = ["Fashion", "Beauty", "Electronics", "Books"];
  const subCategories = ["Men", "Women", "Kids", "Accessories"];

  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState<string[]>([]);

  const [openCategory, setOpenCategory] = useState(false);
  const [openSubCategory, setOpenSubCategory] = useState(false);
  const handleCategoryChange = (event: any) => {
    const {
      target: { value },
    } = event;
    if (value.includes("all")) {
      if (selectedCategories.length === categories.length) {
        setSelectedCategories([]);
      } else {
        setSelectedCategories(categories);
      }
    } else {
      setSelectedCategories(typeof value === "string" ? value.split(",") : value);
    }
  };

  // ----- Handle Sub-Category Change -----
  const handleSubCategoryChange = (event: any) => {
    const {
      target: { value },
    } = event;
    if (value.includes("all")) {
      if (selectedSubCategories.length === subCategories.length) {
        setSelectedSubCategories([]);
      } else {
        setSelectedSubCategories(subCategories);
      }
    } else {
      setSelectedSubCategories(typeof value === "string" ? value.split(",") : value);
    }
  };


  const handleItemClick = (
    event: React.MouseEvent,
    value: string,
    selectedItems: string[],
    setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    event.stopPropagation();
    const selectedIndex = selectedItems.indexOf(value);
    let newSelected: string[] = [];

    if (selectedIndex === -1) newSelected = [...selectedItems, value];
    else newSelected = selectedItems.filter((v) => v !== value);

    setSelectedItems(newSelected);
  };

  // ✅ Select All / Clear All handler
  const handleSelectAll = (
    event: React.MouseEvent,
    allItems: string[],
    selectedItems: string[],
    setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    event.stopPropagation();
    if (selectedItems.length === allItems.length) setSelectedItems([]);
    else setSelectedItems(allItems);
  };

  const handleNextTab = () => {
    if (valueTabs < 4) {
      setValueTabs((prev) => prev + 1);
    }
  };
  const handleNextTab1 = () => {
    if (valueTabs1 < 4) {
      setValueTabs1((prev) => prev + 1);
    }
  };
  const [selectField1, setSelectField1] = React.useState("default");
  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectField1(event.target.value as string);
  };
  const CustomTabPanel: React.FC<TabPanelProps> = ({
    children,
    value,
    index,
    ...other
  }) => (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
  const [Status, setStatus] = React.useState("default");

  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  const a11yProps = (index: number) => ({
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  });
  return (
    <>
      <AuthLayout>
        <div className="authBox signup_box">

          <section className="wrap_viewDemo_steps uh_spc">
            <div className="container">

              <div className="page_head hd_3">
                <h2>
                  {steps[activeStep]}
                </h2>
              </div>


              <div className="steps_grid">
                <div className="step_lt">
                  <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label, index) => {
                      const percentage = Math.round(((index + 1) / steps.length) * 100);
                      return (
                        <Step key={index}>
                          <StepLabel>
                            <Box display="flex" flexDirection="column" alignItems="center">

                              <Typography variant="caption" color="text.secondary" >
                                {percentage}%
                              </Typography>
                            </Box>
                          </StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>

                </div>

                <div className="step_rt">
                  <div className="shadow_box shadow_box1">
                    {activeStep === steps.length ? (
                      <div className="completed_step">
                        <Typography>All steps completed - you're finished!</Typography>
                        <Button onClick={handleReset} sx={{ mt: 2 }}>
                          Reset
                        </Button>
                      </div>
                    ) : (
                      <>
                        {renderStepContent(activeStep)}

                        <div className="btn_flex">
                          <Button
                            className="btn btn_grey"
                            onClick={handleBack}
                            disabled={activeStep === 0}
                          >
                            Back
                          </Button>


                          {activeStep === steps.length - 1 ? (
                            isOtpVerified ? (
                              <p>sds</p>
                            ) : (
                              <Button
                                className="btn btn_primary"
                                onClick={() => navigate('/dashboard')}
                              >
                                Complete Registration
                              </Button>
                            )
                          ) : (
                            <Button
                              className="btn btn_primary"
                              onClick={handleNext}
                            >
                              Next
                            </Button>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>




        </div >
      </AuthLayout >

    </>
  );
};

export default SignupForm;
